import { useEffect } from "react";
import useIsMount from "./useIsMount";

/**
 * a hook to call a function on mount only if a condition is met
 * @param {Boolean} doCallDefault whether to call the callback on mount
 * @param {Function} callback the callback
 */
const useConditionalCallOnMount = (doCallDefault, callback) => {
  const isMount = useIsMount();
  const cb = isMount && doCallDefault && (callback || false);
  useEffect(() => {
    cb && cb();
  }, [cb]);
};

export default useConditionalCallOnMount;
